import { useEffect, useState, useRef } from "react";
import { Container, Box, Avatar, Typography } from "@mui/material"
import { useTranslation } from "react-i18next";
import { useParams, useSearchParams } from "react-router-dom";
import { DoneAll } from "@mui/icons-material";
import { useWaiter } from "../../hooks/waiter/WaiterProvider";
import { delay } from "../../utilities/delay";
import { confirmOrRejectCloseUserAccount } from "../../hooks/actions/users";
import { ConfirmOrRejectCloseUserAccountRequest } from "../../models/requests/ConfirmOrRejectCloseUserAccountRequest";
import { GREEN_MAIN } from "../../theme/colors";

export default function ConfirmaRecjectCloseUserAccount () {
    const { t } = useTranslation();
    const [searchParams] = useSearchParams(); // parametri url
    const initialized = useRef(false)
    const [message, setMessage] = useState('');
    const [messageColor, setMessageColor] = useState("black");

    const code = searchParams.get("code") as string;
    const userId = searchParams.get("userId") as string;
    const { action } = useParams();

    const [icoColor, setIcoColor] = useState<string | undefined>(undefined)
    const {setWaiterView} = useWaiter();
    
    useEffect(()=>{
        if(action && action === "confirm") setIcoColor(GREEN_MAIN)
        if(action && action === "reject") setIcoColor("orange")
    },[])

    useEffect(()=>{
        if (!initialized.current) { // evitare doppie chiamate
            initialized.current = true
            setWaiterView(true)
            delay(2000).then(()=>{
                if(userId === null || code === null)
                {
                    setMessage(t("Richiesta di validazione errata. Riprova."))
                    setMessageColor("red")
                    setWaiterView(false)
                }
                else
                {
                    if(action === undefined){
                        setMessage(t("Non hai definito se vuoi chiudere il tuo account. Riprova!"))
                        setMessageColor('red')
                        setWaiterView(false)
                    }
                    else if (action === "confirm" || action === "reject"){
                        
                        handleAcceptReject().finally();

                    }else {
                        setMessage(t("Non hai definito se vuoi chiudere il tuo account. Riprova!"))
                        setMessageColor('red')
                        setWaiterView(false)
                    }
                }
            })
        }   
    },[action])

    const handleAcceptReject = async () =>{
        try{
            if (action === undefined) {
                setMessage(t("Non hai definito se vuoi chiudere il tuo account. Riprova!"))
                setMessageColor('red')
                setWaiterView(false)
                return;
            }
            
            const request: ConfirmOrRejectCloseUserAccountRequest = {
                userId: userId,
                code: code
            }

            const data = await confirmOrRejectCloseUserAccount(request, action as "confirm" | "reject");
            
            if(data){
                if(action === "confirm"){
                    if(data.confirmedByMailDateTime){
                        setMessage(t("close-account-confirm-success"))
                        setMessageColor(GREEN_MAIN)
                        setWaiterView(false)
                    } else {
                        setMessage(t("close-account-confirm-error"))
                        setMessageColor('red')
                        setWaiterView(false)
                        setIcoColor("red")
                    }
                } else if(action === "reject"){
                    if(data.rejectedByMailDateTime){
                        setMessage(t("close-account-reject-success"))
                        setMessageColor('orange')
                        setWaiterView(false)
                    } else {
                        setMessage(t("close-account-reject-error"))
                        setMessageColor('red')
                        setWaiterView(false)
                        setIcoColor("red")
                    }
                }
            } else {
                setMessage(t("close-account-operation-error"))
                setMessageColor('red')
                setWaiterView(false)
                setIcoColor("red")
            }
            
        }catch(e:any){
            const err = e;
            console.log("error", e)
            const errorMessage = err?.data?.error || err?.data || err?.message || t("close-account-operation-error")
            setMessage(errorMessage)
            setMessageColor('red')
            setWaiterView(false)
            setIcoColor("red")
        }
    }


    return (
        <Container 
            sx={{ 
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent:'center',
            }}
        >
            
            <Avatar sx={{ m: 1, width: 70, height: 70, backgroundColor: icoColor , color: 'white', alignItems:'center', marginTop: '50px'  }}>
                <DoneAll sx={{ fontSize: 50 }}/>
            </Avatar>

            <Box sx={{
                margin:0,
                padding:0,
                height:'50px'
            }}/>

            <Typography component="h1" variant="h3">
                {
                    action && action === "confirm" ? t("close-account-confirming") : action && action === "reject" ? t("close-account-rejected") : t("close-account-confirming")
                }
            </Typography>

            <Box sx={{
                margin:0,
                padding:0,
                height:'50px'
            }}/>

            <Box
                sx={{
                    maxHeight: '200px',
                    overflow:'hidden',
                    textOverflow: 'ellipsis'
                }}
            >
                <Typography color={messageColor} variant="h4">
                    {t(message)}
                </Typography>
            </Box>
            
        </Container>
    )
}

